import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import Separator from "@/app/components/lib/Separator";
import TextArea from "@/app/components/lib/TextArea";

interface Props {
  notes: string;
  setNotes: (value: string) => void;
  disabled?: boolean;
}

const Notes: React.FC<Props> = ({ notes, setNotes, disabled = false }) => {
  const getComapny = useGetCompanyQuery();
  const { show_customer_notes, customer_notes_label } =
    getComapny?.data?.result?.theme?.components?.product ?? {};
  if (!show_customer_notes) return null;
  return (
    <div>
      <Separator startLabel={customer_notes_label ?? ""} marginBottom={8} />
      <TextArea disabled={disabled} value={notes} setValue={setNotes} />
    </div>
  );
};

export default Notes;
